import cfg from '../config/metas-seo.json';

const base = cfg.site_url.replace(/\/+$/, '');

const normalizar = (pathname) => {
  const limpio = (pathname || '/').split('?')[0].replace(/\/+$/, '');
  return limpio === '' ? '/' : limpio;
};

/* Metas de una ruta (títulos, descripción, imagen 1200x630 y canonical absolutos).
   Fuente única: src/config/metas-seo.json. */
export function metasDeRuta(pathname) {
  const ruta = normalizar(pathname);
  const meta = cfg.rutas[ruta];
  if (!meta) return null;
  return {
    title: meta.title,
    description: meta.description,
    image: `${base}${meta.image}`,
    url: ruta === '/' ? `${base}/` : `${base}${ruta}`,
  };
}

export const SEO_SITE = { siteName: cfg.site_name, locale: cfg.locale, card: cfg.twitter_card, type: cfg.og_type };
